import { render, staticRenderFns } from "./behavioralTherapy.vue?vue&type=template&id=8003414c&scoped=true&"
import script from "./behavioralTherapy.vue?vue&type=script&lang=js&"
export * from "./behavioralTherapy.vue?vue&type=script&lang=js&"
import style0 from "./behavioralTherapy.vue?vue&type=style&index=0&id=8003414c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8003414c",
  null
  
)

export default component.exports